import { createTRPCClient, httpBatchLink } from '@trpc/client'
import { AppRouter } from 'api'
import superjson from 'superjson'

import { supabaseSession } from '@/clients/supabase-client.ts'
import { sessionLink, timeoutLink } from '@/clients/trpc-links.ts'
import { apiUrl } from '@/env.ts'

// The only call made without a session
const isPublic = (path: string) => path === 'auth.authenticateWithUsername'

// The server logs which build each request comes from (sync_requests.app_build)
const appBuild: string = import.meta.env.VITE_APP_BUILD ?? 'dev'

export const trpc = createTRPCClient<AppRouter>({
  links: [
    timeoutLink(),
    sessionLink(supabaseSession, isPublic),
    httpBatchLink({
      url: apiUrl('/api/trpc'),
      transformer: superjson,
      headers: ({ opList }) => {
        const token = opList.find((op) => op.context.authToken)?.context
          .authToken as string | undefined

        return token
          ? { Authorization: token, 'x-app-build': appBuild }
          : { 'x-app-build': appBuild }
      },
    }),
  ],
})
